export enum Shared {
}

export enum ExportTypes {
  PDF = 0,
  Excel_xls = 1,
  Excel_xlsx = 2,
  Html = 3,
  ZIP = 4
}

export enum TipoArquivo {
  PED = 1,
  EMP = 2,
  LIQ = 3
}

export enum StatusValidacao {
  SemValidacao = 0,
  NaoValidado = 1,
  Validado = 2
}

export enum TipoContaBancaria {
  Corrente = 1,
  Poupanca = 2
}

export enum CloseModal {
  Cancela,
  Confirma
}



// WEBPACK FOOTER //
// ./src/app/shared/enum/shared.enum.ts